import { put, takeLatest } from 'redux-saga/effects';
import { authenticatedCall } from '../../utils/authenticated-call';
import {
  editProfileAction,
  editProfileErrorAction, editProfileSetLoadingAction,
  editProfileSuccessAction,
  retrieveUserDataAction
} from '../../store/customers/edit-profile.store';
import { editProfileAPI, meAPI } from '../../api/provider/auth/auth-provider';
import { ApiResponse } from '../../api/request';
import { userSetDataAction } from '../../store/user.store';
function* editProfileSaga(data: any) {

  try {
      yield authenticatedCall(editProfileAPI, data.payload)
      yield put(editProfileSuccessAction())
  } catch (error: any) {
    yield put(editProfileErrorAction(error.localizedMessage))
  }
}

function* retrieveUserDataSaga() {

  try {
    let meResult : ApiResponse = yield authenticatedCall(meAPI)
    yield put(userSetDataAction(meResult?.data.data))
    yield put(editProfileSetLoadingAction())
  } catch (error: any) {
    yield put(editProfileSetLoadingAction())
  }
}

export function* editProfileSagas() {
  yield takeLatest(editProfileAction.type, editProfileSaga);
  yield takeLatest(retrieveUserDataAction.type, retrieveUserDataSaga);
}
